import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"]
})
export class ConfirmDialogComponent implements OnInit {
  public icon?: string = "pi-info-circle";
  public successButtonName = "OK";
  public cancelButtonName = $localize`Закрыть`;
  public continueButtonName?: string;
  public message?: string;
  public subMessage?: string;
  public checkedStatus = false;
  public showStatus = false;
  public onlyCancel = false;
  public viewIcon = true;
  public changeBtnsPosition = false;
  public env = environment;
  public actionButton = false;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {
    if (!this.config.header) {
      this.config.header = $localize`Предупреждение`;
    }
  }

  public ngOnInit(): void {
    this.setData();
  }

  public setData(): void {
		for (let k in this.config.data) {
			(this as any)[k] = this.config.data[k];
		}
  }

  public close(successButtonHandle?: boolean): void {
    this.ref.close({ successButtonHandle, checked: this.checkedStatus });
  }

  public continue(): void {
    this.ref.close({ continueButtonHandle: true });
  }
}
